import { LoaderCircle } from "@/shared/svg/loader-circle/LoaderCircle";

const Loader = () => {
  return <LoaderCircle />;
};

export { Loader };
